export default function SignupLink() {
  return (
    <a
      href="/app/signup"
      className="font-medium text-white hover:text-red-50 px-3 lg:px-4 py-2 flex items-center transition duration-150 ease-in-out group whitespace-nowrap"
    >
      Sign Up{' '}
      <span className="tracking-normal text-white group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">
        -&gt;
      </span>
    </a>
  );
}
